import "@/index.css";
import { useEffect } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/shared/CookieConsent";
import { trackPageview } from "@/lib/analytics";
import Landing from "@/pages/Landing";
import Account from "@/pages/Account";
import Opportunities from "@/pages/Opportunities";
import LegalPage from "@/pages/LegalPage";
import AuthCallback from "@/pages/AuthCallback";
import Insights from "@/pages/Insights";
import AdminLeads from "@/pages/AdminLeads";
import Company from "@/pages/Company";
import AmbassadorProgram from "@/pages/AmbassadorProgram";
import DriverDirectory from "@/pages/DriverDirectory";
import AdminDrivers from "@/pages/AdminDrivers";
import BrokerLanding from "@/pages/BrokerLanding";
import BrokerPortal from "@/pages/BrokerPortal";
import DriverPortal from "@/pages/DriverPortal";

// The session token lives in an httpOnly cookie set by the backend, not in JS —
// this makes sure every request automatically includes it.
axios.defaults.withCredentials = true;

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);

  // Detect session_id synchronously during render (before ProtectedRoute logic runs)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/account" element={<Account />} />
      <Route path="/opportunities" element={<Opportunities />} />
      <Route path="/legal/:slug" element={<LegalPage />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/admin/leads" element={<AdminLeads />} />
      <Route path="/company" element={<Company />} />
      <Route path="/ambassador-program" element={<AmbassadorProgram />} />
      <Route path="/drivers" element={<DriverDirectory />} />
      <Route path="/admin/drivers" element={<AdminDrivers />} />
      <Route path="/brokers" element={<BrokerLanding />} />
      <Route path="/broker-portal" element={<BrokerPortal />} />
      <Route path="/driver-portal" element={<DriverPortal />} />
    </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.1, duration: 1.2, smoothWheel: true }}>
      <div className="App font-body">
        <BrowserRouter>
          <AppRoutes />
          <CookieConsent />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
